import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Drawer from 'components/Drawer'
import { Form as AntdForm } from 'antd'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const CenteredTitle = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;
  padding-bottom: 1rem;
`
export const CompanyName = styled.div`
  font-size: 1.25rem;
  color: ${COLORS.GREY_T_20};
  font-weight: 700;
`
export const DomainName = styled.div`
  font-size: 0.95rem;
  color: ${COLORS.GREY_T_60};
  font-weight: 500;
`
export const ItemsFlex = styled(Flex)`
  padding: 0.3rem 0.8rem;
  align-items: flex-start;
`
export const LightText = styled(Flex)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
  gap: 10px;
  flex: 1 1 0;
`
export const BoldText = styled.div`
  font-size: 0.975rem;
  font-weight: 700;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_30};
  flex: 1 1 0;
  margin-left: 2rem;
`
export const ModeText = styled(BoldText)`
  text-transform: capitalize;
`
export const LocationText = styled.div`
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
`
export const CountContainer = styled(Flex)`
  padding: 1rem;
  justify-content: center;
  align-items: center;
`
export const DriveCount = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  border-right: ${props =>
    props.border && `1px solid ${COLORS.PRIMARY_GREY_T_90}`};
  border-left: ${props =>
    props.border && `1px solid ${COLORS.PRIMARY_GREY_T_90}`};
`
export const CountTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;
  color: ${COLORS.GREY_T_60};
`
export const BoldCount = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.5rem;
`
export const FooterFlex = styled(Flex)`
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
